module.exports = __webpack_public_path__ + "static/media/Stellar Ora King Headboard - 180 cm_Light Beige.7b0d5ea4.png";